module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo3.b0638f93.png";